import { gql, TypedDocumentNode } from '@apollo/client';
import {
  OvertimeExternalSignatureUpload,
  OvertimeExternalSignatureUploadVariables,
} from './__generated__/OvertimeExternalSignatureUpload.mutation';

const OvertimeExternalSignatureUploadMutation: TypedDocumentNode<
  OvertimeExternalSignatureUpload,
  OvertimeExternalSignatureUploadVariables
> = gql`
  mutation OvertimeExternalSignatureUpload(
    $input: OvertimeExternalSignatureUploadInput!
    $file: Upload!
  ) {
    overtimeExternalSignatureUpload(input: $input, file: $file) {
      id
      fullName
      type
      imagePath
      createdAt

      overtime {
        id

        signatures {
          id
          type
        }

        pdfPath
        status
        updatedAt
      }
    }
  }
`;

export default OvertimeExternalSignatureUploadMutation;
